import * as pdfjs from "pdfjs-dist";
import "pdfjs-dist/web/pdf_viewer.css";
import React, { useCallback, useMemo } from "react";
import { useEffect, useRef, useState } from "react";
import { CircularProgress, Tooltip } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import debounce from 'lodash/debounce';

import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import { pageNavigationPlugin } from '@react-pdf-viewer/page-navigation';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/full-screen/lib/styles/index.css';
import '@react-pdf-viewer/page-navigation/lib/styles/index.css';
import { ScrollMode, SpecialZoomLevel, Viewer } from "@react-pdf-viewer/core";

import { DASHBOARD, NEW_DATA_ENTRY, EDIT_WORK, QA_REVIEW } from '../../../../routeNames.js';
import { getPdfPrev } from "../../../../redux/grid/action.js";

const gap = 5;
const pdfPageNumber = "secondPdf_"
const canvasId = 'canvasId_'
const container = "container2"
const selectPdfPage = "selectPdfPage"

//thumbnail const 
const thumbnailGap = 60;
const numThumbnailToShow = 20;
const halfPagesThumbnail = Math.floor(numThumbnailToShow / 2);
const ThumbnailScale = 0.1
const thumbnailContainer = 'thumbnailContainer'
const singleThumbWraper = 'singleThumbnailWrap'
const thumbnail = 'thumbnail_'
const thubnailCanvas = 'thumbnailCanvas_'



const PdfViewerComponent = (props) => {



    const {
        isunvisitedPage,
        handleDocumentLoad,
        loader,
        setLoader,
        currentPage,
        setCurrentPage,
        numPages,
        setNumPages,
        fileUrl,
        gotoPageNumber,
        viewPage,
        jobData

    } = props

    ////////////////// uniquestates  ////////////////
    const scrolldivRef1 = useRef()
    const isLoadingRef = useRef(true);

    ///////////////////////////////

    const [pageDetails, setPageDetails] = useState([]);
    const [scale, setScale] = useState(1)
    const [activeElement, setActiveElement] = useState([])
    const [pdf, setPdf] = useState(null)
    const [activeTop, setActiveTop] = useState(0)
    const [totalHeight, setTotalHeight] = useState(0)
    const [ruler, setRuler] = useState({})
    const [displayCurrentPage, setDisplayCurrentPage] = useState(0)
    //prev pdf states
    const [triggerPrevNextPdf, setTriggerPrevNextPdf] = useState({ prev: false, next: false })
    const [commonPdfMain, setCommonMain] = useState(null)
    let pdfUp = useRef(null)
    let pdfDown = useRef(null)
    const viewerRef = useRef(null);
    const [numPagesPDF1, setNumPagesPDF1] = useState(0);
    const [loadingPrev, setLoadingPrev] = useState(false);
    const [loadingNext, setLoadingNext] = useState(false);

    const [visitedPages, setVisitedPages] = useState([]);
    const [fitToScreen, setFitToScreen] = useState(0)

    //===============thumbnail =================
    const [isThumbnail, setIsThumbnail] = useState(false)
    const [thumbnailCurrentPage, setThumbnailCurrentPage] = useState(1)

    const currentPath = window.location.pathname;



    useEffect(() => {
        const loadDocument = async () => {
            try {
                setLoader(true)
                const loadingTask = pdfjs.getDocument(fileUrl);
                const loadedPdf = await loadingTask.promise;
                setPdf(loadedPdf);
                setNumPages(loadedPdf.numPages);

            } catch (error) {
                console.error("error on loading URl:", error)
            }
        };

        if (fileUrl) {

            loadDocument();
        }

    }, [fileUrl]);

    useEffect(() => {


        const renderStart = async () => {
            if (!pdf) {
                console.warn("pdf is not there 2", pdf)
                return;
            }

            let page_Height = 0;
            let large_page_width = 0


            let updatedDetails = []
            for (let pageNum = 1; pageNum <= numPages; pageNum++) {
                let page = null
                try {
                    page = await pdf.getPage(pageNum);
                } catch (error) {
                    console.error('@@@ test Error page 2:', pageNum, error)
                }
                if (page) {
                    const widthPts = Math.abs(page?._pageInfo.view[2] - page?._pageInfo.view[0]); // Width in points
                    const heightPts = Math.abs(page?._pageInfo.view[3] - page?._pageInfo.view[1]); // Height in points
                    let pageDetails = {
                        width: [90, 270].includes(page?._pageInfo.rotate) ? heightPts : widthPts,
                        height: [90, 270].includes(page?._pageInfo.rotate) ? widthPts : heightPts,
                        rotate: page?._pageInfo.rotate,
                        isActive: true,
                        cumulativeHeight: page_Height,
                        page: page,
                        _pageIndex: page._pageIndex
                    };
                    page_Height += ([90, 270].includes(page?._pageInfo.rotate) ? widthPts : (heightPts)) + gap;
                    updatedDetails.push(pageDetails)
                    if (large_page_width < ([90, 270].includes(page.rotate)?heightPts:widthPts)) {
                        large_page_width = ([90, 270].includes(page.rotate)?heightPts:widthPts)
                    }

                }

            }

            setPageDetails(updatedDetails);
            setTotalHeight(page_Height);

            const innerWidth =  window.innerWidth <= 0 ? Math.max(1904, window.innerWidth) - 100 : window.innerWidth -100 //to prevent the -ve value 
            let initScale = parseFloat((innerWidth / large_page_width).toFixed(2));
            if (initScale <= 0) {
                initScale = 1;
              }
            setFitToScreen(initScale)
            setScale(initScale)
            handleDocumentLoad(numPages) //   for the  index page 
            setLoader(false)
        };
        
        renderStart();
    }, [pdf]);


    const pagesToShow = 10;
    const halfPages = Math.floor(pagesToShow / 2);

    useEffect(() => {

        if (pageDetails.length === 0) {
            setActiveElement([]);
            return;
        }


        const start = Math.max(0, currentPage - halfPages);
        const end = Math.min(numPages, start + pagesToShow);


        if (currentPage > numPages - halfPages) {
            const startAdjustment = Math.max(0, numPages - pagesToShow);
            setActiveElement(pageDetails.slice(startAdjustment, numPages));
            setActiveTop(((pageDetails[startAdjustment].cumulativeHeight - (gap * startAdjustment)) * scale) + (gap * startAdjustment));
        } else {
            setActiveElement(pageDetails.slice(start, end));
            const top = ((pageDetails[start]?.cumulativeHeight - (gap * start)) * scale) + (gap * start);
            setActiveTop(top);
        }
        setDisplayCurrentPage(currentPage)



    }, [pageDetails, scale, currentPage]);


    const gotopage = useCallback((pagenumber) => {
        if (pagenumber > 0) {
            const currentscrollLocation = (pageDetails[pagenumber - 1]?.cumulativeHeight - (pagenumber * gap)) * scale + (pagenumber * gap)
            if(!isNaN(currentscrollLocation)){
                scrolldivRef1.current.scrollTo({
                    top: currentscrollLocation ,
                    behavior: "smooth",
                });
            }
        }

    }, [pageDetails, scale])

    /////////////////////// unvisited page ////////////////////////
    useEffect(() => {
        if (numPages > 0 && isunvisitedPage) {
            const initialVisited = new Array(numPages).fill(false);
            initialVisited[currentPage - 1] = true;
            setVisitedPages(initialVisited);
        }
    }, [numPages]);


    useEffect(() => {
        if (isunvisitedPage) {


            const timer = setTimeout(() => {
                setVisitedPages((prev) => {
                    const newVisited = [...prev];
                    newVisited[currentPage - 1] = true;
                    return newVisited;
                })

            }, 1000);


            return () => clearTimeout(timer);
        }
    }, [currentPage])

    ///////////////////////////////////////////////)
    const rotateCount = useRef(0)
    const handleRotate = useCallback(debounce((currentPage, position) => {
        const newPageDetails = [...pageDetails];
        const targetPage = newPageDetails[currentPage - 1];

        if (!targetPage) return;
        const oldHeight = targetPage.height;
        targetPage.rotate = (targetPage.rotate + (90 * position)) % 360;
        if (position % 2 !== 0) { // Check if position is odd
            [targetPage.width, targetPage.height] = [targetPage.height, targetPage.width];
        }
        const heightDifference = targetPage.height - oldHeight;

        for (let i = currentPage; i < newPageDetails.length; i++) {
            newPageDetails[i].cumulativeHeight += heightDifference;
        }
        const element = document.getElementById(canvasId + (currentPage - 1));
        if (element) {
            element.remove();
        }
        //remove alsoThumbnail
        const thumbnail = document.getElementById(thubnailCanvas + (currentPage - 1));
        if (thumbnail) {
            thumbnail.remove();
        }

        setTotalHeight(prev => prev + heightDifference)
        setPageDetails(newPageDetails);
        rotateCount.current = 0;
    },300, [pageDetails]));

    const handleScroll = (e) => {
        if (e.currentTarget) {
            const { scrollTop:scrollTop1, scrollHeight, clientHeight } = e.currentTarget;
            // Check if we've reached the bottom
            if(scrollTop1<=4){
                setCurrentPage(1);
            }
            else if (Math.round(scrollTop1 + clientHeight) >= scrollHeight) {
                setCurrentPage(numPages);
            }else{
                const scrollTop = e.currentTarget.scrollTop + 250;
    
                let isLastElement = true
                    for (let i = 0; i < pageDetails.length; i++) {
                        const pageHeight = ((pageDetails[i].cumulativeHeight - (i * gap)) * scale) + (i * gap);
        
        
                    if (scrollTop < pageHeight) {
                            if (currentPage != i) {
                                setCurrentPage(i);
                            }
        
                            isLastElement = false
                            break;
                        }
        
                    }
                if (isLastElement) {
                    setCurrentPage(numPages);
                }
            }
        }

    };

    const handleChange = (e) => {
        setDisplayCurrentPage(e.target.value)

    }
    const handleKeyDown = (event) => {
        ["e", "E", "+", "-", "."].includes(event.key) && event.preventDefault()
        if (event.key === 'Enter') {

            gotopage(displayCurrentPage >= numPages ? numPages : displayCurrentPage);
        }
    };



    ///////////////////////////////////////////////
    const handleZoom = (status) => { // status : -1 | 1
        const newScale = scale + (0.1 * status);
        if (newScale >= 0.1 && newScale <= 3.5) {

            setActiveElement([])

            setScale(newScale);
            // setTimeout(() => {
            //     if (scrolldivRef1.current) {
            //         scrolldivRef1.current.scrollBy({
            //             top: 2,
            //             behavior: 'smooth',
            //         });
            //     }
            // }, 500)
        }

    }

    //////////////////////////////////////////////


    ////////////////////////// append canvas //////////////////

    useEffect(() => {
        const createCanvas = (rotation = 0, scaleFactor, pageDetails) => {
            let viewport;
            let page = pageDetails?.page
            if (!page) {
                return
            }

            viewport = page.getViewport({
                scale: scaleFactor,
                rotation
            });

            const canvas = document.createElement("canvas");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.id = canvasId + pageDetails._pageIndex;

            const context = canvas.getContext("2d");
            const renderContext = {
                canvasContext: context,
                viewport
            };
            return page.render(renderContext).promise.then(() => {
                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const { data } = imageData;
                // Check if any pixel value is 255 (indicating the canvas is not blank)
                const isNotBlank = data.some(value => value === 255);

                return { success: true, pageNumber: page._pageIndex + 1, element: canvas, rotation,isPageLoaded:isNotBlank };
            });

        };
        const loadCanvas = async () => {
            const pdfContainer = document.getElementById(container);
            const idsWithoutCanvas = [];
            isLoadingRef.current = true;
            if (pdfContainer) {
                const divs = pdfContainer.getElementsByClassName(selectPdfPage);
                for (const div of divs) {

                    if (!isLoadingRef.current) break;  // Stop if the loading state changes
                    const noCanvas = Number(div.id.split("_")[1]);
                    const isActive = document.getElementById(`${pdfPageNumber}${noCanvas}`);

                    if (isActive && !isActive.querySelector('canvas')) {

                        idsWithoutCanvas.push(noCanvas);
                        const pdSinglePageDetails = pageDetails[noCanvas];

                        let canvas = await createCanvas(pdSinglePageDetails.rotate, scale, pdSinglePageDetails);
                        if(canvas?.isPageLoaded === false){
                            canvas = await createCanvas(pdSinglePageDetails.rotate, scale, pdSinglePageDetails);
                        }
                        canvas.element.id = canvasId + noCanvas;

                        if (!div.querySelector('canvas')) {
                            div.querySelector('span')?.remove()
                            div.appendChild(canvas.element);
                        }
                    }
                }
            }

        };
        const loadTimeOut = setTimeout(() => {

            loadCanvas();
        }, 300)

        return () => {
            clearTimeout(loadTimeOut)
            isLoadingRef.current = false;
        };
    }, [activeElement])

    //////////////////////////////////////////////////////////
    //////////////////////// goto location //////////////////////////

    const handleRuler = useCallback((event) => {
        if (event.altKey) {
            if (event.keyCode === 71 && Object.keys(ruler)?.length>0) { // 'G'
                event.preventDefault();

                const scrollPos = ((pageDetails[ruler?.pageNumber]?.cumulativeHeight - (ruler?.pageNumber * gap)) * (scale)) + (ruler.top) + (ruler?.pageNumber * gap);

                scrolldivRef1.current.scrollTo({
                    top: scrollPos -300,
                    behavior: 'smooth',
                });
            }
            if (event.keyCode === 81 && ruler) { // 'Q'
                event.preventDefault();
                setRuler({});
            }
        }
    }, [ruler, scale]);

    useEffect(() => {
        window.addEventListener('keydown', handleRuler);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('keydown', handleRuler);
        };
    }, [handleRuler])


    const options = [
        {
            key: " Fit to screen",
            value: fitToScreen
        },
        {
            key: " Actual Width",
            value: 1
        },
        {

            key: "100%",
            value: 1
        },
        {
            key: "150%",
            value: 1.5
        }
        ,
        {
            key: "200%",
            value: 2
        },
        {
            key: "250%",
            value: 2.5
        },
        {
            key: "300%",
            value: 3
        },

    ];

    const handleChangeselect = (value) => {
        setScale(value)
        if (scale != value) {
            setActiveElement([])
            setTimeout(() => {
                if (scrolldivRef1.current) {
                    scrolldivRef1.current.scrollBy({
                        top: 10,
                        behavior: 'smooth',
                    });
                }
            }, 100)
        }

    };

    /////////////////////// jump to page for patital save job //////////////////
    useEffect(() => {
        if (gotoPageNumber) {
            gotopage(gotoPageNumber)
        }
    }, [gotoPageNumber])




    const [open, setOpen] = useState(false);

    const handleTooltip = () => {
        setOpen(!open);
    };
    const handleTooltipClose = () => {
        setOpen(false);
    };
    ///////////////////////////// Thumbnial Logic ////////////////////////

    const [activeThumbnail, setActiveThumbnail] = useState([])
    const [activeThumbnailTop, setActiveThumbnailTop] = useState([])

    useEffect(() => {

        if (pageDetails.length === 0) {
            setActiveThumbnail([]);
            return;
        }


        const start = Math.max(0, thumbnailCurrentPage - halfPagesThumbnail);
        const end = Math.min(numPages, start + numThumbnailToShow);


        if (thumbnailCurrentPage > numPages - halfPagesThumbnail) {
            const startAdjustment = Math.max(0, numPages - numThumbnailToShow);
            setActiveThumbnail(pageDetails.slice(startAdjustment, numPages));
            setActiveThumbnailTop(((pageDetails[startAdjustment].cumulativeHeight - (thumbnailGap * startAdjustment)) * ThumbnailScale) + (thumbnailGap * startAdjustment));
        } else {
            setActiveThumbnail(pageDetails.slice(start, end));
            const top = ((pageDetails[start].cumulativeHeight - (thumbnailGap * start)) * ThumbnailScale) + (thumbnailGap * start);
            setActiveThumbnailTop(top);
        }




    }, [pageDetails, thumbnailCurrentPage]);


    const handleScrollThumbnail = (e) => {
        if (e.currentTarget) {
            const scrollTop = e.currentTarget.scrollTop + 250;

            let isLastElement = true
            for (let i = 0; i < pageDetails.length; i++) {
                const pageHeight = ((pageDetails[i].cumulativeHeight - (i * thumbnailGap)) * ThumbnailScale) + (i * thumbnailGap);


                if (scrollTop < pageHeight) {
                    if (thumbnailCurrentPage != i) {
                        setThumbnailCurrentPage(i);
                    }

                    isLastElement = false
                    break;
                }

            }
            if (isLastElement) {
                setThumbnailCurrentPage(numPages);
            }
        }

    };

    /////////////////////load thumbnail useEffect///////////////////////

    useEffect(() => {
        const createCanvas = (rotation = 0, scaleFactor, pageDetails) => {
            let viewport;
            let page = pageDetails?.page
            if (!page) {
                return
            }

            viewport = page.getViewport({
                scale: scaleFactor,
                rotation
            });

            const canvas = document.createElement("canvas");
            canvas.width = viewport.width;
            canvas.height = viewport.height;
            canvas.id = canvasId + pageDetails._pageIndex;

            const context = canvas.getContext("2d");
            const renderContext = {
                canvasContext: context,
                viewport
            };
            return page.render(renderContext).promise.then(() => {
                return { success: true, pageNumber: page._pageIndex + 1, element: canvas, rotation };
            });

        };
        const loadCanvas = async () => {
            const ThumbnailParentDiv = document.getElementById(thumbnailContainer);
            const idsWithoutCanvas = [];
            // isLoadingRef.current = true;
            if (ThumbnailParentDiv) {
                const divs = ThumbnailParentDiv.getElementsByClassName(singleThumbWraper);
                for (const div of divs) {

                    // if (!isLoadingRef.current) break;  // Stop if the loading state changes
                    const noCanvas = Number(div.id.split("_")[1]);
                    const isActive = document.getElementById(`${thubnailCanvas}${noCanvas}`);

                    if (!isActive) {

                        idsWithoutCanvas.push(noCanvas);
                        if(pageDetails?.length <= 0) return
                        const pdSinglePageDetails = pageDetails[noCanvas];

                        const canvas = await createCanvas(pdSinglePageDetails?.rotate, 0.1, pdSinglePageDetails);

                        canvas.element.id = thubnailCanvas + noCanvas;

                        if (!div.querySelector('canvas')) {
                            div.querySelector('span')?.remove()

                            div.appendChild(canvas.element);
                        }
                    }
                }
            }

        };
        const loadTimeOut = setTimeout(() => {

            loadCanvas();
        }, 100)

        return () => {
            clearTimeout(loadTimeOut)
            // isLoadingRef.current = false;
        };

    }, [isThumbnail, activeThumbnail])

    const handleThumbnailClick = (event) => {
        if (event.target.tagName === 'CANVAS') {
            const canvasId = event.target.id;
            gotopage(Number(canvasId.split("_")[1]) + 1)
        }

    }
   
    const debouncedHandleRotate = (currentPage, rotatePosition) => {
        rotateCount.current += rotatePosition; // Update rotate count
        handleRotate(currentPage, rotateCount.current); // Use the debounced function
      };



         //=================================| react pdf viewer prev and next pdf viewer |=====================================
                  const pageNavigation = pageNavigationPlugin({
                    enableShortcuts: false,
                });
            
                const { jumpToPage } = pageNavigation;
            
            
            
                const renderToolbar = (Toolbar) => (
                    <Toolbar>
                        {function (slots) {
                            const {
                                CurrentPageInput, EnterFullScreen, GoToFirstPage, GoToNextPage, GoToPreviousPage, GoToLastPage, NumberOfPages, Zoom, ZoomIn, ZoomOut,
                            } = slots;
            
                            return (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        width: '100%',
                                    }}
                                >
                                     <Tooltip disableInteractive title={'Original PDF'} placement='top' arrow>
                                            <div className="ms-6 ps-4  "onClick={closeTrggerpdfModal} >
                                                <i class="bi bi-file-pdf"></i>
                                            </div>
                                        </Tooltip>
            
            
                                    <div className='d-flex flex-row justify-content-between align-items-center' style={{ padding: '0px 2px', marginLeft: '100px' }}>
                                       
                                        <GoToFirstPage />
                                        <GoToPreviousPage />
                                        <CurrentPageInput />
                                        / <NumberOfPages />
                                        <GoToNextPage />
                                        <GoToLastPage />
                                       
            
            
                                    </div>
                                    <div style={{ width: '52%', display: 'flex', alignItems: 'center', marginLeft: '7rem' }}>
                                        {/* {window.location.pathname === NEW_DATA_ENTRY &&
                                  <Tooltip disableInteractive title={JSON.stringify(falseIndices)} placement='top' arrow>
                                    <div >Unvisited Pages: {viewPage?.filter(value => value === false).length}</div>
                                  </Tooltip>
                                } */}
                                        <div className='d-flex flex-row justify-content-between align-items-center' style={{ padding: '0px 2px', marginLeft: '42rem' }}>
                                            <ZoomOut />
                                            <Zoom />
                                            <ZoomIn />
                                        </div>
                                    </div>
                                    <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                    </div>
                                </div>
                            );
                        }}
                    </Toolbar>
                );
            
          const defaultLayoutPluginInstance = defaultLayoutPlugin({
                renderToolbar, toolbarPlugin: {
                    pageNavigationPlugin: {
                        enableShortcuts: false,
                    },
                },
                fullScreenPlugin: {
                    onEnterFullScreen: (zoom) => {
                        zoom(SpecialZoomLevel.PageFit);
                        defaultLayoutPluginInstance.toolbarPluginInstance.scrollModePluginInstance.switchScrollMode(
                            ScrollMode.Wrapped
                        );
                    },
                    onExitFullScreen: (zoom) => {
                        zoom(SpecialZoomLevel.PageWidth);
                        defaultLayoutPluginInstance.toolbarPluginInstance.scrollModePluginInstance.switchScrollMode(
                            ScrollMode.Vertical
                        );
                    },
                },
                sidebarTabs: (defaultTabs) => [
                    defaultTabs[0], // Thumbnails tab
                ],
                // thumbnailPlugin: {
                //     // thumbnailWidth: 0,po
                // },
        
            });
           
             const openTrggerpdfModalPrev = () => {
                setTriggerPrevNextPdf({prev:true,next:false})
            }
             const openTrggerpdfModalNext = () => {
                setTriggerPrevNextPdf({prev:false,next:true})
            }
            const closeTrggerpdfModal = () => {
                setTriggerPrevNextPdf(false)
            }
            const handleOpenPrevPDF = () => {
          
                  setCommonMain(pdfUp.current)
                  openTrggerpdfModalPrev()
              }
          
              
              const handleOpenNextPDF = async () => {
                  setCommonMain(pdfDown.current);
                  openTrggerpdfModalNext();
          
              };
               const isViewFirstJob = useMemo(() => {
              return (
                  !jobData?.is_first_sub_job &&
                  jobData?.is_large_batch_job &&
                  currentPath === NEW_DATA_ENTRY 
                 
              );
          }, [jobData?.is_first_sub_job,jobData?.is_last_sub_job, jobData?.is_large_batch_job, currentPath]);
          
             const isViewLastJob = useMemo(() => {
              return (
                  !jobData?.is_last_sub_job &&
                  jobData?.is_large_batch_job &&
                  currentPath === NEW_DATA_ENTRY 
                  
              );
          }, [jobData?.is_last_sub_job,jobData?.is_first_sub_job, jobData?.is_large_batch_job, currentPath]);
          
             useEffect(() => {
              const fetchPdfBlob = async (url) => {
                  try {
                      const res = await fetch(url);
                      const blob = await res.blob();
                      return URL.createObjectURL(blob);
                  } catch (error) {
                      console.error('Error fetching PDF blob:', error);
                      return null;
                  }
              };
              let isHavePdfBlobUp = pdfUp.current
              let isHavePdfBlobDown = pdfUp.current
              if(jobData==''){
                 isHavePdfBlobUp=null 
                 isHavePdfBlobDown=null
              }
          
              if (isViewFirstJob && isHavePdfBlobUp === null) {
                  setLoadingPrev(true);
                  getPdfPrev({ type: "previous", sub_job: jobData?.job })(async (response) => {
                      if (response.status && response?.data?.job_pages) {
                          const blobUrl = await fetchPdfBlob(response.data.job_pages);
                          if (blobUrl) {
                              pdfUp.current = blobUrl;
                          }
                      }
                      setLoadingPrev(false);
                  });
              }
          
              if (isViewLastJob && isHavePdfBlobDown === null) {
                  setLoadingNext(true);
                  getPdfPrev({ type: "next", sub_job: jobData?.job })(async (response) => {
                      if (response.status && response?.data?.job_pages) {
                          const blobUrl = await fetchPdfBlob(response.data.job_pages);
                          if (blobUrl) {
                              pdfDown.current = blobUrl;
                          }
                      }
                      setLoadingNext(false);
                  });
              }
          }, [isViewFirstJob, isViewLastJob, jobData]);
          
              const hideAllButtons  = useMemo(() => {
                  return (
                      jobData?.is_last_sub_job &&
                      jobData?.is_large_batch_job &&
                      currentPath === NEW_DATA_ENTRY&&
                      jobData?.is_first_sub_job
                      
                  );
              }, [jobData?.is_last_sub_job,jobData?.is_first_sub_job,jobData?.is_large_batch_job,currentPath]);
          
        
        
             useEffect(() => {
            const handleEsc = (event) => {
              if (event.key === 'Escape') {
                closeTrggerpdfModal(); // Call any function like closing a modal
              }
            };
        
            window.addEventListener('keyup', handleEsc);
        
            // Cleanup the event on unmount
            return () => {
              window.removeEventListener('keyup', handleEsc);
            };
          }, []);
        
        
            useEffect(() => {
                if (!!(triggerPrevNextPdf?.prev && commonPdfMain != null) && numPagesPDF1 > 0) {
                    setTimeout(() => {
                        jumpToPage(numPagesPDF1 - 1); 
        
                      //    setTimeout(() => {
                      //       const lastPageEl = document.querySelector(
                      //           `[data-testid="core__text-layer-${numPagesPDF1 - 1}"]`
                      //       );
                      //       if (lastPageEl) {
                      //           lastPageEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
                      //       }
                      //   }, 1000);
                    }, 300); 
                }
            }, [triggerPrevNextPdf?.prev, numPagesPDF1, jumpToPage]);
      
      
      
       

 //=================================| react pdf viewer prev and next pdf viewer |=====================================

 

    return (
        <>
           
              {/* =========================|next and prevpage modal|========================= */}
                                {!!((triggerPrevNextPdf.prev ||triggerPrevNextPdf.next) &&commonPdfMain!=null) && <div className="position-absolute   border border-danger"
                                    style={{
                                        height: 'calc(100vh - 35px)',
                                        width: '100vw',
                                        zIndex: 1,
                    
                                    }}>
                    
                                    <Viewer
                                        fileUrl={commonPdfMain}
                                        plugins={[defaultLayoutPluginInstance,pageNavigation ]}
                                        onDocumentLoad={(e) => setNumPagesPDF1(e.doc.numPages)}
                                    />
                    
                                </div>}
                                {/* =========================|next and prevpage modal|========================= */}
            <div className='d-flex gap-3 ps-4 align-items-center '
                style={{
                    height: "36px",
                    backgroundColor: "#0397a7",
                }}>

                   
                    

                <div style={{width:'50%',display:'flex',gap:'20px'}}>
                    <div className="d-flex gap-2">
                        <Tooltip disableInteractive title={'Rotate Left'} placement='top' arrow>


                            <div className="pdf-icon">
                                <i onClick={() => debouncedHandleRotate(currentPage, -1)} className="bi bi-arrow-counterclockwise" style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Rotate Left"></i>
                            </div>

                        </Tooltip>
                        <Tooltip disableInteractive title={'Rotate Right'} placement='top' arrow>

                            <div className="pdf-icon">
                                <i onClick={() => debouncedHandleRotate(currentPage, 1)} className="bi bi-arrow-clockwise" style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Rotate Right"></i>
                            </div>

                        </Tooltip>
                    </div>
                    <div className="d-flex gap-2">
                        <Tooltip disableInteractive title={' First Page'} placement='top' arrow>

                            <div className="pdf-icon">
                                <i onClick={() => gotopage(1)} className="bi bi-caret-up" style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="First Page"></i>
                            </div >

                        </Tooltip>
                        <Tooltip disableInteractive title={'Previous Page'} placement='top' arrow>

                            <div className="pdf-icon">
                                <i onClick={() => gotopage(currentPage - 1 >= 0 ? currentPage - 1 : 1)} className="bi bi-chevron-up" style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Previous Page"></i>
                            </div>

                        </Tooltip>
                    </div>

                    <div className="d-flex gap-2 text-light">
                        <input
                            type="number"
                            value={displayCurrentPage}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            placeholder="Enter a number"
                            className="border-0 rounded no-arrows px-2 "
                            style={{
                                width: "70px",
                                outline: "none",
                                color: 'black',
                                height: "fit-content",
                            }}
                        />
                        / {numPages}
                    </div>

                    <div className="d-flex gap-1">
                        <Tooltip disableInteractive title={'Next Page'} placement='top' arrow>

                            <div className="pdf-icon">
                                <i
                                    className="bi bi-chevron-down  "
                                    onClick={() => gotopage(currentPage + 1 < numPages ? currentPage + 1 : numPages)}
                                    style={{ color: "white", cursor: "pointer" }}
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-title="Next Page"></i>
                            </div>

                        </Tooltip>
                        <Tooltip disableInteractive title={'Last Page'} placement='top' arrow>

                            <div className="pdf-icon">

                                <i className="bi bi-caret-down" onClick={() => gotopage(numPages)} style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Last Page"></i>
                            </div>

                        </Tooltip>
                    </div >

                    {isunvisitedPage && 
                    <Tooltip disableInteractive title={
                        `Page number: ${viewPage
                            .map((visited, index) => (visited ? null : index + 1))
                            .filter(index => index !== null)
                            .join(', ')}`
                    } placement='top' arrow>

                        <div className="pdf-icon text-light">
                            Unvisited pages : {viewPage
                                ?.filter(value => value === false).length}
                        </div>

                    </Tooltip>}
                     {!hideAllButtons&& <>
                    {isViewFirstJob && (
                        <Tooltip disableInteractive title={'Previous PDF'} placement='top' arrow>
                            <div className="pdf-icon" >
                                {loadingPrev ? (
                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                ) : (
                                    <i
                                        className="bi bi-box-arrow-up"
                                        style={{ color: "white" }}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Last Page"
                                        onClick={handleOpenPrevPDF}
                                    ></i>
                                )}
                            </div>
                        </Tooltip>
                    )}

                    {isViewLastJob && (
                        <Tooltip disableInteractive title={'Next PDF'} placement='top' arrow>
                            <div className="pdf-icon" >
                                {loadingNext ? (
                                    <div className="spinner-border spinner-border-sm text-light" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                ) : (
                                    <i
                                        className="bi bi-box-arrow-down"
                                        style={{ color: "white" }}
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        data-bs-title="Last Page"
                                        onClick={handleOpenNextPDF}
                                    ></i>
                                )}
                            </div>
                        </Tooltip>
                    )}
                    </>}

                </div>
               <div style={{width:'50%',display:'flex',gap:'20px'}}>
                    <Tooltip disableInteractive title={'Zoom Out'} placement='top' arrow>

                    <div className="pdf-icon">
                        <i
                            onClick={() => {
                                handleZoom(-1);
                            }}
                            className="bi bi-zoom-out"
                            style={{ color: "white" }}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            data-bs-title="Zoom Out"></i>
                    </div>

                    </Tooltip>
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                    <div>
                        <Tooltip
                            PopperProps={{
                                disablePortal: true,
                            }}
                            onClose={handleTooltipClose}
                            open={open}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={
                                <>
                                    <ul style={{ listStyleType: 'none', padding: 0, marginBottom: '16px' }}>
                                        {options.map((option) => (
                                            <li
                                                key={option.key}
                                                onClick={() => {
                                                    handleChangeselect(option.value)
                                                    handleTooltipClose()

                                                }}
                                                style={{
                                                    margin: '0px 0',
                                                    padding: '4px 4px',
                                                    cursor: 'pointer',
                                                    borderRadius: '4px',
                                                    textAlign: "center",
                                                }}
                                            >
                                                {option.key}
                                            </li>
                                        ))}
                                    </ul>
                                </>
                            }
                        >
                            <button className='bg-light' onClick={handleTooltip}>{parseInt(scale * 100)}%  ▼</button>
                        </Tooltip>
                    </div>
                    </ClickAwayListener>

                    <Tooltip disableInteractive title={'Zoom In'} placement='top' arrow>
                    <div className="pdf-icon">
                        <i onClick={() => handleZoom(1)} className="bi bi-zoom-in" style={{ color: "white" }} data-bs-toggle="tooltip" data-bs-placement="top" data-bs-title="Zoom In "></i>
                    </div>
                    </Tooltip>
               </div>
                <Tooltip disableInteractive title={'Thumbnail '} placement='top' arrow>
                 <div style={styles.thumbnailImageicon} className="cursor-pointer">
                <i onClick={() => setIsThumbnail(!isThumbnail)}  className="bi bi-grid text-light "></i>
                    </div>           
                    </Tooltip>
            </div>

            <div className="d-flex" style={styles.parentContainer}>
                {/* >>>>>>>>>>>>>>>>>>>>>>Thumbnails>>>>>>>>>>>>>>>>>>>>>>> */}
                <div className={`${isThumbnail ? "" : "d-none"}   `} style={{ maxWidth: "275px", flex: "1", }} >
                    <div className="bg-light me-2 ">

                        <div
                            onScroll={handleScrollThumbnail}
                            style={styles.sideBar}

                        >
                            <div
                                style={{

                                    display: "flex",
                                    justifyContent: "center",
                                    overflow: "none",
                                    height: `${((totalHeight - (numPages * thumbnailGap)) * ThumbnailScale) + numPages * thumbnailGap}px`,
                                    position: "relative",
                                    backgroundColor:"white"

                                }}>

                                <div
                                    // style={styles.thumbnailcontainer}
                                    id={thumbnailContainer}

                                    style={{
                                        minWidth: '100%',
                                        padding: "50px 0px",
                                        transition: 'transform 0.1s ease-out',
                                        display: 'grid',
                                        gap: `${thumbnailGap}px 10px`,
                                        // height: 'fit-content',
                                        // minHeight: 'calc(100vh - 72px)',
                                        position: "absolute",
                                        top: `${activeThumbnailTop}px`,
                                        overflow: "scroll",
                                        justifyItems: 'center',
                                        backgroundColor: 'white'

                                    }} className='overflow-auto'
                                    onClick={handleThumbnailClick}
                                >


                                    {
                                        activeThumbnail.map((item) => (
                                            <div
                                                style={{
                                                    width: item.width * ThumbnailScale,
                                                    height: item.height * ThumbnailScale,
                                                    position: "relative",
                                                    boxShadow: item._pageIndex + 1 === currentPage ? "0px 0px 5px 5px rgba(0, 0, 0, 0.57)" : "0px 0px 10px 5px rgba(0, 0, 0, 0.2)"
                                                }}

                                                className={`${singleThumbWraper} d-flex justify-content-center align-content-center flex-wrap  `}
                                                key={"0_" + item._pageIndex}
                                                id={`${thumbnail + item?._pageIndex}`}
                                            >
                                                <p className="position-absolute" style={{ top: "-20px", left: "50%", transform: "translateX(-50%)" }}>{item._pageIndex + 1}</p>
                                                <CircularProgress size={20} color="inherit" />
                                            </div>
                                        ))
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                {/* pdf  main content  */}

                <div style={styles.mainContainer}>



                    <div
                        onScroll={handleScroll}
                        style={{
                            maxWidth: '100vw',
                            height: 'calc(100vh - 72px)',
                            overflowY: "scroll",
                            backgroundColor:'white'

                        }}
                        id='scrollDiv'
                        ref={scrolldivRef1}
                    >
                        <div


                            style={{

                                display: "flex",
                                justifyContent: "center",
                                overflow: "none",
                                // backgroundColor: 'aliceblue',
                                height: `${((totalHeight - (numPages * gap)) * scale) + numPages * gap}px`,
                                position: "relative",
                                backgroundColor:"white"

                            }}>

                            <div

                                id={container}
                                className="container"
                                style={{
                                    minWidth: '100%',
                                    // marginTop: "50px",
                                    // transform: `scale(${scale+1})`,
                                    transformOrigin: 'center',
                                    transition: 'transform 0.1s ease-out',
                                    display: 'grid',
                                    gap: `${gap}px 10px`,
                                    height: 'fit-content',
                                    minHeight: 'calc(100vh - 72px)',
                                    position: "absolute",
                                    top: `${activeTop}px`,
                                    justifyItems: 'center',
                                    backgroundColor: 'white'

                                }}
                            >
                                {
                                    activeElement?.map((item) => (

                                        <div
                                            key={item._pageIndex}
                                            // style={styles.container}
                                            id={`${pdfPageNumber}${item?._pageIndex}`}
                                            data-page-number_="1"
                                            style={{
                                                width: `${item.width * scale}px`,
                                                height: `${item.height * scale}px`,
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                position: 'relative',
                                                backgroundColor: 'white',

                                            }}
// ======
                                            onDoubleClick={(e) => {
                                                e.stopPropagation(); // Prevent the click from bubbling up to the parent

                                                // Get the bounding rectangle of the clicked div
                                                const rect = e.currentTarget.getBoundingClientRect();
                                                // Calculate the click position relative to the clicked div
                                                const clickY = e.clientY - rect.top;
                                                setRuler({ pageNumber: item._pageIndex, top: clickY, scale: scale ,clickPossition:item.cumulativeHeight+clickY })

                                            }}
                                            className={selectPdfPage}
                                        >
                                            {/* ====== */}
                                            <div>
                                            {(item?._pageIndex === ruler?.pageNumber) && <div
                                            key={123}
                                                style={{
                                                    position: 'absolute',
                                                    height: "5px",
                                                    width: "100%",
                                                    backgroundColor: "#ad0505",
                                                    top: `${ruler.top*(scale/ruler?.scale)}px`
                                                }}
                                                className="ruler_div "

                                            >


                                            </div>}
                                            </div>
                                            <CircularProgress size={scale*50} color="inherit" />
                                        </div>

                                    )

                                    )


                                }




                            </div>
                        </div>



                    </div>
                </div>
                {loader && 
                    <div style={{ position: "absolute", top: "50%", left: " 50%", transform: "translate(-50%, -50%)" }}>
                        <div className="spinner-border " role="status" style={{ width: "3rem", height: "3rem", color: "#1ba2a8 " }}>
                            <span className="sr-only"></span>
                        </div>
                    </div>
                }
            </div >
        </>
    );
};


export default React.memo(PdfViewerComponent);


const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: '1px solid rgba(0, 0, 0, 0.09)',
        position: 'relative',
        height: '125.45px',
        width: '125.45px',
    },
    text: {
        color: 'rgb(87, 87, 87)',
        fontWeight: 'bold',
        position: 'absolute',
        top: '-25px',
    },
    innerDiv: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'aliceblue',

    },
    checkbox: {
        position: 'absolute',
        left: '0px',
        bottom: '0px',
    },
    parentContainer: {
        display: "flex",
        backgroundColor: "rgb(3, 151, 167)",
        padding: " 0px 25px",

    },

    sideBar: {
        maxWidth: "275px",
        backgroundColor: "white",
        height: "calc(100vh - 75px)",
        overflowY: "scroll",
    },
    mainContainer: {
        flex: "5",
        position:'relative'
    },
    thumbnailcontainer: {
        // marginTop: `${thumbnailGap}px`,
        display: "grid",
        gridTemplateColumns: "1fr",
        gap: `${thumbnailGap}px`,
        padding: "10px",
        justifyItems: "center",
    },
    thumbnailImageicon:{
        position: "absolute",
        top: "85px",
        left: "5px",
        cursor: "pointer",
    }


};



